<template>
  <ul class="menu-nav ">
    <li class="menu-item  " aria-haspopup="true">
      <a
        href="../patients"
        class="btn btn-light font-weight-bolder font-size-sm"
        >{{ $t("header_menu.patients_btn") }}</a
      >
    </li>

    <li class="menu-item  menu-item-active " aria-haspopup="true">
      <a
        v-b-modal.modal-add-patient
        href="#"
        data-toggle="modal"
        data-target="#addPatient"
        class="btn btn-info font-weight-bolder font-size-sm"
        >{{ $t("header_menu.add_patient") }}</a
      >
    </li>
    <div class="code-on-header">
      <h4>
        {{ $t("header_menu.doctor_code") }} <strong> {{ doctor.code }}</strong>
      </h4>
    </div>

    <b-modal id="modal-add-patient" :title="$t('header_menu.add_patient')">
      <form>
        <div class="form-group ">
          <label>Email</label>
          <input
            id="email"
            type="text"
            class="form-control"
            v-model.trim="email"
            :class="{
              invalid:
                ($v.email.$dirty && !$v.email.required) ||
                ($v.email.$dirty && !$v.email.email)
            }"
          />
          <span
            class="helper-text text-muted"
            v-if="$v.email.$dirty && !$v.email.required"
            >{{ $t("header_menu.enter_email") }}
          </span>
          <span
            class="helper-text text-muted"
            v-else-if="$v.email.$dirty && !$v.email.email"
            >{{ $t("header_menu.email_not_valid") }}
          </span>
        </div>
        <div class="form-group">
          <label>{{ $t("header_menu.pass") }}</label>
          <input
            id="password"
            type="password"
            class="form-control"
            v-model.trim="password"
            :class="{
              invalid:
                ($v.password.$dirty && !$v.password.required) ||
                ($v.password.$dirty && !$v.password.minLength)
            }"
          />
          <span
            class="helper-text text-muted"
            v-if="$v.password.$dirty && !$v.password.required"
            >{{ $t("header_menu.enter_pass") }}
          </span>
          <span
            class="helper-text text-muted"
            v-else-if="$v.password.$dirty && !$v.password.minLength"
            >{{ $t("header_menu.min_length") }}
            {{ $v.password.$params.minLength.min }}
          </span>
        </div>
        <div class="form-group">
          <label>{{ $t("header_menu.last_name") }}</label>
          <input
            id="last_name"
            type="text"
            class="form-control"
            v-model.trim="last_name"
            :class="{
              invalid:
                ($v.last_name.$dirty && !$v.last_name.required) ||
                ($v.last_name.$dirty && !$v.last_name.maxLength)
            }"
          />
          <!--<span class="form-text text-muted"></span>-->
          <span
            v-if="$v.last_name.$dirty && !$v.last_name.required"
            class="helper-text text-muted"
            >{{ $t("header_menu.enter_last_name") }}</span
          >
          <span
            class="helper-text text-muted"
            v-else-if="$v.last_name.$dirty && !$v.last_name.maxLength"
            >{{ $t("header_menu.max_length") }}
            {{ $v.last_name.$params.maxLength.max }}
          </span>
        </div>
        <div class="form-group">
          <label>{{ $t("header_menu.first_name") }}</label>
          <input
            id="first_name"
            type="text"
            class="form-control"
            v-model.trim="first_name"
            :class="{
              invalid:
                ($v.first_name.$dirty && !$v.first_name.required) ||
                ($v.first_name.$dirty && !$v.first_name.maxLength)
            }"
          />
          <span
            v-if="$v.first_name.$dirty && !$v.first_name.required"
            class="helper-text text-muted"
            >{{ $t("header_menu.enter_first_name") }}</span
          >
          <span
            class="helper-text text-muted"
            v-else-if="$v.first_name.$dirty && !$v.first_name.maxLength"
            >{{ $t("header_menu.max_length") }}
            {{ $v.first_name.$params.maxLength.max }}
          </span>
        </div>
        <div class="form-group">
          <label>{{ $t("header_menu.phone_number") }}</label>
          <input
            id="phone_number"
            type="text"
            class="form-control"
            v-model.trim="phone_number"
            :class="{
              invalid:
                ($v.phone_number.$dirty && !$v.phone_number.required) ||
                ($v.phone_number.$dirty && !$v.phone.maxLength)
            }"
          />
          <span
            v-if="$v.phone_number.$dirty && !$v.phone_number.required"
            class="helper-text text-muted"
            >{{ $t("header_menu.enter_phone_number") }}</span
          >
          <span
            class="helper-text text-muted"
            v-else-if="$v.phone_number.$dirty && !$v.phone_number.maxLength"
            >{{ $t("header_menu.max_length") }}
            {{ $v.phone_number.$params.maxLength.max }}
          </span>
          <span class="form-text text-muted"
            >{{ $t("header_menu.for_instance") }} +38 050 846 5692</span
          >
        </div>
        <div class="form-group">
          <label>{{ $t("header_menu.comment") }}</label>
          <textarea
            id="fcm_text"
            type="text"
            class="form-control"
            rows="4"
            maxlength="1024"
            v-model.trim="comment"
            :class="{
              invalid:
                ($v.comment.$dirty && !$v.comment.required) ||
                ($v.comment.$dirty && !$v.comment.maxLength)
            }"
          ></textarea>
          <span
            class="helper-text text-muted"
            v-if="$v.comment.$dirty && !$v.comment.maxLength"
            >{{ $t("header_menu.max_length") }}
            {{ $v.comment.$params.maxLength.max }}
          </span>
        </div>
      </form>

      <template #modal-footer="{cancel, ok}">
        <b-button variant="secondary" @click="cancel()">
          {{ $t("header_menu.cancel") }}
        </b-button>

        <b-button variant="primary" type="submit" @click="handleSubmitAdd()">
          {{ $t("header_menu.save") }}
        </b-button>
      </template>
    </b-modal>
  </ul>
</template>
<style lang="scss">
@import "~vuetify/dist/vuetify.css";

div.code-on-header h4 {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
</style>
<script>
import {
  required,
  maxLength,
  email,
  minLength
} from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";

import {
  REMOVE_BODY_CLASSNAME,
  ADD_BODY_CLASSNAME
} from "@/core/services/store/htmlclass.module.js";

export default {
  name: "KTMenu",
  data: () => ({
    gamer: null,
    password: "",
    email: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    comment: ""
  }),
  validations: {
    email: { email, required },
    password: { required, minLength: minLength(6) },
    first_name: { required, maxLength: maxLength(32) },
    phone_number: { required, maxLength: maxLength(14) },
    last_name: { required, maxLength: maxLength(32) },
    comment: { maxLength: maxLength(1024) }
  },
  mounted: async function() {},
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
    handleSubmitAdd() {
      let currentObj = this;
      try {
        if (this.$v.$invalid) {
          this.$v.$touch();
          return;
        }
      } catch (e) {
        return;
      }

      try {
        this.showLoader(true);
        this.axios
          .post(
            "https://us-central1-blink-fb.cloudfunctions.net/manageUser/add-gamer",
            {
              create_date: Date.now(),
              password: this.password,
              email: this.email,
              doctor_id: this.getUserId,
              first_name: this.first_name,
              last_name: this.last_name,
              phone_number: this.phone_number,
              comment: this.comment
            },
            {
              headers: {
                apikey: "63b5689d-a975-46ae-a1df-f9eed01f18ad"
              }
            }
          )
          .then(function() {
            currentObj.$v.$reset();
            currentObj.$root.$emit("bv::hide::modal", "modal-add-patient");
            currentObj.showLoader(false);
            window.location.reload();
          })
          .catch(function() {
            currentObj.showLoader(false);
          });
      } catch (e) {
        this.showLoader(false);
      }
    },
    showLoader(stateLoading) {
      if (stateLoading) {
        this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      } else {
        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
      }
    }
  },
  computed: {
    ...mapGetters(["getUserId"]),
    ...mapState({
      doctor: state => state.doctor.doctor
    })
  }
};
</script>
